import { render, staticRenderFns } from "./password_reset.vue?vue&type=template&id=dca24f86&scoped=true"
import script from "./password_reset.vue?vue&type=script&lang=js"
export * from "./password_reset.vue?vue&type=script&lang=js"
import style0 from "./password_reset.vue?vue&type=style&index=0&id=dca24f86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca24f86",
  null
  
)

export default component.exports